import Page from "../components/Page";
import { fetchDuels } from "../actions/predictions";
import { connect } from "react-redux";
import Navigation from "../components/Navigation";

const Rules = () => {
  return (
    <Page classes="min-h-[100%] from-white to-white">
      <Navigation title="Правила гри" />
      <div className="px-4 pt-12 pb-8">
        <h3 className="text-primary m-0 uppercase font-bold mb-4 border-b-2 border-primary">
          Регламент турніру
        </h3>

        <p className="text-black mb-4">
          ✅ Усі учасники, які зареєструвалися у грі, надсилають свої прогнози
          на тур УПЛ. Дедлайном кожного туру{" "}
          <strong>є час старту першого матчу </strong> туру.
        </p>

        <p className="text-black mb-4">
          ✅ Усі учасники, які відправили хоча б один прогноз до дедлайну туру,
          беруть участь{" "}
          <strong>у жеребкуванні, яке визначає суперника на тур </strong> для
          кожного учасника гри.
        </p>
        <p className="text-black mb-4">
          ✅ Дуель (батл) - це матч між двома учасниками турніру, які
          прогнозують однаковий набір футбольних матчів.
        </p>
        <p className="text-black mb-4">
          ✅ Учасникам дуелі пропонується спрогнозувати точні рахунки футбольних
          матчів. Прогнози на футбольні матчі відправляються заздалегідь та є
          недоступними до перегляду іншими користувачами до початку конкретного
          футбольного матчу, на який було відправлено прогноз.
        </p>
        <p className="text-black mb-4">
          ✅ Змінювати прогноз на конкретний футбольний матч можна безліч разів
          до завершення дедлайну - запланованого часу початку футбольного матчу.{" "}
        </p>
        <p className="text-black mb-4">
          ✅ За перемогу в дуелі (батлі) учасник отримує <strong>3 очки</strong>
          , за нічию <strong>1 очко</strong>.
        </p>
        <p className="text-black mb-4">
          ✅ У разі рівності очок у турнірній таблиці, вище буде той учасник,
          який матиме перевагу: за різницею забитих та пропущених м'ячів,
          кількістю забитих м'ячів{" "}
        </p>

        <h3 className="text-primary m-0 uppercase font-bold mb-4 border-b-2 border-primary">
          Розрахунок дуелі
        </h3>

        <p className="text-black mb-4">
          ✅ Розрахунок результату дуелі здійснюється шляхом послідовного
          порівняння прогнозів двох учасників.
        </p>
        <p className="text-black mb-4">
          ✅ Якщо учасник точно спрогнозував рахунок матчу, йому зараховується
          "дабл" (<strong>+2 голи</strong>).
        </p>
        <p className="text-black mb-4">
          ✅ <strong>+1 гол</strong> зараховується за наступними правилами:
          <ul className="mt-2">
            <li>
              1️⃣ правильно спрогнозовано <strong>результат матчу</strong>{" "}
              (перемога, нічия, поразка){" "}
              <strong>на відміну від суперника</strong>
              <br />
              <br />
              <i>
                Наприклад, якщо <strong>Учасник 1</strong> спрогнозував рахунок{" "}
                <strong>2:0</strong>, а <strong>Учасник 2</strong> спрогнозував
                рахунок <strong>1:1</strong>, то після завершення матчу з
                рахунком <strong>3:1</strong>, <strong>Учасник 1</strong>{" "}
                отримає +1 бал в дуелі (батлі).
              </i>
              <br />
              <br />
            </li>
            <li>
              2️⃣ правильно спрогнозовано{" "}
              <strong>різницю м'ячів у рахунку </strong>{" "}
              <strong>на відміну від суперника </strong>
              <br />
              <br />
              <i>
                Наприклад, якщо <strong> Учасник 1</strong> спрогнозував рахунок{" "}
                <strong>2:0 (+2)</strong>, а <strong>Учасник 2</strong>{" "}
                спрогнозував рахунок <strong>3:0 (+3)</strong>, то після
                завершення матчу з рахунком <strong>3:1 (+2)</strong>,{" "}
                <strong>Учасник 1</strong> отримає +1 бал в дуелі (батлі).
              </i>
            </li>
          </ul>
        </p>
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  loaded: state.app.loaded,
  players: state.players,
  me: state.user.me,
});

const mapDispatchToProps = (dispatch) => ({
  fetchDuels: () => dispatch(fetchDuels()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Rules);
